import * as React from "react";

function SvgArrow(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M16.7 3.3L10 10 3.3 3.4 0 6.7l10 10v-.1l10-9.9z" /></svg>;
}

export default SvgArrow;